module.exports = __webpack_public_path__ + "static/media/check.3f6435db.svg";